<template>
  <b-container fluid class='header'>
    <b-jumbotron fluid class='pt-1'>
      <b-container>
        <h1 class='text-white d-inline'>Admin</h1>
      </b-container>
    </b-jumbotron>

    <b-container class="mb-4" fluid>
      <b-card header="Controls" class="mt-4">
        <LoadingButton :loading="loading_check_content_credits" @click="check_content_credits" class="mr-2">Check content credits</LoadingButton>
        <LoadingButton :loading="loading_check_tasks" @click="check_tasks" class="mr-2">Check tasks</LoadingButton>
        <LoadingButton :loading="loading_check_deploy_queue" @click="check_deploy_queue">Check Deploy queue</LoadingButton>
      </b-card>

      <b-card no-body header="Users" class="mt-4">
        <b-table :items="users" :fields="user_fields" show-empty>
          <template v-slot:cell(created)='data'>
            {{data.item.created | date}}
          </template>
        </b-table>
      </b-card>

      <b-card no-body header="Sites" class="mt-4">
        <b-table :items="all_sites" :fields="site_fields" show-empty>
          <template v-slot:cell(created)='data'>
            {{data.item.created | date}}
          </template>

          <template v-slot:cell(view)='data'>
            <a :href="data.item.view" target="_blank">View</a>
          </template>

          <template v-slot:cell(name)='data'>
            <a :href="`/site/${data.item.id}`" target="_blank">{{data.item.name}}</a>
          </template>
        </b-table>
      </b-card>
    </b-container>
  </b-container>
</template>

<script>

import { db } from '@/main.js'
import api from '@/lib/api.js'
import ItemMixin from '@/mixins/Item.js'
import moment from 'moment'

export default {
  name: 'admin',
  props: ['profile'],
  mixins: [ItemMixin],
  data() {
    return {
      loading_check_content_credits: false,
      loading_check_tasks: false,
      loading_check_deploy_queue: false,
      users: [],
      sites: [],
      user_fields: [
        {key: 'created'},
        {key: 'name'},
        {key: 'email'},
        {key: 'payment_method'},
      ],
      site_fields: [
        {key: 'created'},
        {key: 'name'},
        {key: 'user'},
        {key: 'status'},
        {key: 'view'},

        // monthly_posts
        // monthly_citations
      ]
    }
  },
  computed: {
    all_sites() {
      let all_sites = []
      for (let site of this.sites) {
        if (site.trial_end) {
          let days_left = moment(site.trial_end.toDate()).diff(moment(), 'days')
          if (days_left <= 0) {
            site.status = `Expired`
          } else {
            site.status = `Trial ${days_left} days left`
          }
        } else {
          let price = 100 + site.monthly_posts * 40 + site.monthly_citations * 4
          site.status = `£${price} / month (${site.monthly_posts} posts, ${site.monthly_citations} citations)`
        }

        for (let user of this.users) {
          if (site.user === user.id) {
            site.user = user.email
          }
        }

        site.view = `https://${site.domain ? site.domain : `${site.id}.netlify.app`}`

        all_sites.push(site)
      }

      return all_sites
    }
  },
  firestore: function () {
    return {
      users: db.collection('user').orderBy('created', 'desc'),
      sites: db.collection('site').orderBy('created', 'desc')
    }
  },
  methods: { // TODO make this button work
    async check_content_credits() {
      this.loading_check_content_credits = true
      await api.check_content_credits()
      this.loading_check_content_credits = false
    },
    async check_tasks() {
      this.loading_check_tasks = true
      await api.check_tasks()
      this.loading_check_tasks = false
    },
    async check_deploy_queue() {
      this.loading_check_deploy_queue = true
      await api.check_deploy_queue()
      this.loading_check_deploy_queue = false
    }
  },
  metaInfo() {
    return {
      title: `Admin`
    };
  },
}
</script>

<style scoped>

</style>
